import {
  Alert,
  Box,
  Chip,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

const ListLocalisationResume = ({ localisations, loading }) => {
  return (
    <Grid item xs={12}>
      <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          sx={{ mb: 2 }}
        >
          <Stack direction="row" spacing={1.25} alignItems="center">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.main",
                backgroundColor: "#EAF2FF",
              }}
            >
              <PlaceOutlinedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={800}>
                Localisations assignées
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Zones concernées par cet AMI
              </Typography>
            </Box>
          </Stack>
          <Chip
            size="small"
            label={`${localisations?.length || 0} localisation${
              (localisations?.length || 0) > 1 ? "s" : ""
            }`}
            variant="outlined"
            color="primary"
          />
        </Stack>

        {loading && (
          <Grid container spacing={1.5}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item}>
                <Skeleton variant="rectangular" height={54} sx={{ borderRadius: 2 }} />
              </Grid>
            ))}
          </Grid>
        )}

        {!loading && localisations?.length > 0 && (
          <Grid container spacing={1.5}>
            {localisations.map((localisation, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: "#FFFFFF",
                    height: "100%",
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <PlaceOutlinedIcon color="action" fontSize="small" />
                    <Typography variant="body2" fontWeight={600}>
                      {localisation.nom_lot || "Non spécifié"}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}

        {!loading && (!localisations || localisations.length === 0) && (
          <Alert severity="info" variant="outlined">
            Aucune localisation assignée.
          </Alert>
        )}
      </Paper>
    </Grid>
  );
};

export default ListLocalisationResume;
